import { h, Component } from 'preact';
import SectionLoader from 'components/bolt/sectionLoader/sectionLoader';
import { joinClasses, accessNested } from 'utils/utils';
import { sectionsWithParent } from 'pages/bolt_pages';
import Store from 'store/store';
import { smoothScrollTo } from 'utils/smoothScroll';
import { getHeaderHeight } from 'utils/bolt';
import s from 'components/bolt/customScroll/customScroll.sss';

export default class CustomScroll extends Component {
	constructor(props) {
		super(props);
		this.autoUpdateUrl = accessNested(props.store, `appData.pages.${props.id}.data.autoUpdateUrl`, null);
		this.preloadAllSections = accessNested(props.store, `appData.pages.${props.id}.data.preloadAllSections`, false);
		this.onResize = this.onResize.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.goToHash = this.goToHash.bind(this);
		this.recalculateElementsPositions = this.recalculateElementsPositions.bind(this);
		this.isScrolling = 0;
	}

	async componentDidMount() {
		Store.emit('UPDATE_HUB_ACTIVE_PERCENTAGE');

		const scrollContainer = document.getElementById('mainScroll');
		if (this.autoUpdateUrl) {
			window.addEventListener('resize', this.onResize);
			scrollContainer.addEventListener('scroll', this.onScroll);
			this.recalculateElementsPositions();
		}

		await this.dataLoadingPromise;
		this.dataLoadingPromise = null;
		const hash = location.hash.slice(1);
		if (hash) {
			this.goToHash(hash);
		}
	}

	componentWillUnmount() {
		const scrollContainer = document.getElementById('mainScroll');
		window.removeEventListener('resize', this.onResize);
		scrollContainer.removeEventListener('scroll', this.onScroll);
	}

	scrollToTheElem(scrollToElem) {
		let headerHeight = accessNested(this.props, 'store.client.headerHeight', getHeaderHeight());

		let scrollContainer = document.getElementById('mainScroll');
		this.isScrolling++;
		smoothScrollTo(scrollContainer, scrollToElem, 600, {
			callback: () => this.isScrolling--,
			offset: headerHeight
		});
	}

	goToHash(hash) {
		const scrollContainer = document.getElementById('mainScroll');
		let scrollToElem = document.querySelector(`[data-hash-wrapper="${hash}"]`) || document.getElementById(hash);

		if (scrollToElem !== null) {
			this.setState({ hash: hash });
			this.scrollToTheElem(scrollToElem, scrollContainer);
			// Remove hash if the URL is not dynamically updated as we scroll
			// if (!this.autoUpdateUrl) {
			// 	history.replaceState(null, '', '.' + location.search);
			// }
		}
	}

	onResize() {
		if (this.dataLoadingPromise) {
			return;
		}
		this.recalculateElementsPositions();
		this.checkActiveElement();
	}

	onScroll() {
		if (this.dataLoadingPromise || this.isScrolling > 0) {
			return;
		}
		this.checkActiveElement();
	}

	recalculateElementsPositions() {
		if (!this.base || !this.autoUpdateUrl) {
			return;
		}

		this.parentTop = this.base.offsetTop;
		// let children = this.$customScroll?.children || [];
		let children = this.$customScroll?.querySelectorAll('[data-hash-wrapper]') || [];
		this.elements = [...children].map(e => {
			const hash = e.getAttribute('data-hash-wrapper');
			return {
				url: ['bottom', 'top', 'hero'].some(attr => hash?.toLowerCase()?.includes(attr)) ? '.' + location.search : (location.search + '#' + hash),
				position: e.offsetTop + e.offsetHeight * .3 + this.parentTop
			};
		});
	}

	checkActiveElement() {
		if (!this.elements || !this.autoUpdateUrl) {
			return;
		}

		this.recalculateElementsPositions();

		const scrollContainer = document.getElementById('mainScroll');
		let currentPosition = this.parentTop + scrollContainer.scrollTop + (window.innerHeight - this.parentTop) * .2;

		let withDistance = this.elements.map(e => ({ ...e, dist: Math.abs(e.position - currentPosition) }));
		let closest = withDistance.sort((a, b) => a.dist - b.dist)[0];
		let url = closest?.url;
		if (!url || (this.currentPath && this.currentPath === url)) {
			return;
		}
		this.currentPath = url;
		let fullURL = new URL(url, location.href);
		const activePage = Store.get().activePage;
		if (location.href !== fullURL && this.props.id === activePage) {
			history.replaceState(null, '', url);
		}
	}

	render(props) {
		const { store } = props;
		const activePageSections = sectionsWithParent.filter(page => page.parent === store.activePage);
		const sectionFullPage = activePageSections.length === 1;
		let headerHeight = accessNested(store, 'client.headerHeight', 64);

		return (
			<div
				style={{ paddingTop: headerHeight }}
				data-section={props.id}
				class={joinClasses(sectionFullPage && s.fullPage, s.innerContainer)}
				ref={e => this.$customScroll = e}
				key="sections"
			>
				{activePageSections.map((section) => {
					const sectionData = accessNested(this.props, `store.appData.pages.${section.id}`, {});
					const hash = sectionData?.data?.disableMainHash ? null : sectionData?.data?.hash || sectionData?.id;

					const sectionProps = {
						store,
						appData: store.appData,
						client: store.client,
						id: section.id,
						getter: section.getter,
						[section.id]: store[section.id],
						isSection: true,
						isLoneSection: activePageSections.length === 1,
						sectionFullPage,
						isPreloaded: this.preloadAllSections || section.isPreloaded,
						parentIsScrolling: this.isScrolling,
						goToHash: this.goToHash
					};

					return 	(
						<div data-hash-wrapper={hash} key={section.id}>
							{!section.isPreloaded
								? <SectionLoader {...sectionProps} key={section.id} />
								: <section.component {...sectionProps} key={section.id} />
							}
						</div>
					);
				})}
				<div data-hash-wrapper="bottom" key="bottom" />
			</div>
		);
	}
}
